import { UserBase } from "domain/model/base";

export default class User extends UserBase {};
